<template>
  <div class="org-tree">
    <div v-if="!tree.length" class="org-tree__empty">
      Todavía no hay nadie en el organigrama. Ubica a alguien de la lista "Sin ubicar".
    </div>
    <div v-else class="org-tree__scroll">
      <ul class="org-tree__roots">
        <org-chart-branch
          v-for="branch in tree"
          :key="branch.person.personId"
          :branch="branch"
          :areas="areas"
          :highlight-person-id="highlightPersonId"
          :is-expanded="isExpanded"
          is-root
          @select-person="$emit('select-person', $event)"
          @toggle="toggle"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import OrgChartBranch from './OrgChartBranch.vue';
import { buildTree, collectAncestorIds } from '../utils/org-chart.utils';

// Niveles visibles al abrir: las cabezas y sus reportes directos.
// Desde el tercer nivel las ramas parten cerradas.
const VISIBLE_LEVELS = 2;

export default {
  name: 'OrgChartTree',
  components: { OrgChartBranch },
  props: {
    // Lista plana de personas ubicadas: { personId, name, title, area, managerPersonId, ... }
    nodes: { type: Array, default: () => [] },
    areas: { type: Object, default: () => ({}) },
    highlightPersonId: { type: [Number, String], default: null }
  },
  data() {
    return {
      // personId -> true/false cuando el usuario abrió o cerró la rama a mano.
      expandedOverrides: {}
    };
  },
  computed: {
    tree() {
      return buildTree(this.nodes);
    }
  },
  watch: {
    highlightPersonId: {
      immediate: true,
      handler(id) {
        if (id === null || id === undefined) return;
        collectAncestorIds(this.nodes, id).forEach(ancestorId => {
          this.$set(this.expandedOverrides, ancestorId, true);
        });
      }
    }
  },
  methods: {
    isExpanded(branch) {
      const override = this.expandedOverrides[branch.person.personId];
      if (override !== undefined) return override;
      return branch.depth < VISIBLE_LEVELS - 1;
    },
    toggle(personId) {
      const branch = this.findBranch(this.tree, personId);
      if (!branch) return;
      this.$set(this.expandedOverrides, personId, !this.isExpanded(branch));
    },
    findBranch(branches, personId) {
      for (const branch of branches) {
        if (branch.person.personId === personId) return branch;
        const found = this.findBranch(branch.children, personId);
        if (found) return found;
      }
      return null;
    }
  }
};
</script>

<style scoped>
.org-tree {
  min-width: 0;
  max-width: 100%;
}

/* El scroll horizontal queda dentro del contenedor, nunca en la página. */
.org-tree__scroll {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 8px 4px 16px;
}

.org-tree__roots {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  width: max-content;
  min-width: 100%;
  margin: 0;
  padding: 0;
}

.org-tree__empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--pw-text-muted);
}
</style>
